export default __webpack_public_path__ + "static/media/misc-books5.2835ec77.jpg";